import styled from 'styled-components'

const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
`
export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 150px;
`
export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
`
export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`
export const TabFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
  gap: 15px;
`
export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`
export default ButtonWrapper
